<template>
  <cashbacks-list :partner_id="partnerId"></cashbacks-list>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import CashbacksList from '@pages/cashbacks/list/list-cashbacks'

  export default {
    async setup () {
      const partnerId = computed(() => router.currentRoute.value.params.partner_id)

      return {
        partnerId,
      }
    }, 

    components: {
      CashbacksList,
    }
  }
</script>